import { inject, Injectable, signal } from '@angular/core';
import { BsApiService, BsChatService, GenericResponseCode, getRouteForKey } from '@brightside-web/desktop/data-access/core-services';
import { CampaignConfig, CampaignCTA, CampaignPayload } from '../models/campaign.models';
import { Router } from '@angular/router';
import { ServiceInventoryService } from '@brightside-web/desktop/data-access/service-inventory';


@Injectable({
  providedIn: 'root'
})
export class CampaignsService {

  private _bsApi = inject(BsApiService);
  private _router = inject(Router);
  private _serviceInventoryService = inject(ServiceInventoryService);
  private _bsChatService = inject(BsChatService);
  private _campaigns = signal<CampaignConfig[] | undefined | null>(undefined);
  public readonly campaigns = this._campaigns.asReadonly();

  private _activeCampaign = signal<CampaignConfig | null | undefined>(undefined);
  public readonly activeCampaign = this._activeCampaign.asReadonly();

  constructor() { }

  getCampaigns() {
    this._bsApi.get<CampaignPayload>('api-mobile', '/campaign').subscribe({
      next: response => {
        if (response.result.code === GenericResponseCode.SERVICE_OK) {
          this._campaigns.set(response.payload.campaigns)
        }
      },
      error: err => {}
    })
  }

  setActiveCampaignFromCard(campaign: CampaignConfig) {
    this._activeCampaign.set(campaign);
    this.campaignRouteHandler(campaign.card.cta1);
  }

  campaignRouteHandler(cta: CampaignCTA) {
    if (cta.serviceInventoryKey === 'chat_action') {
      this._bsChatService.showChat();
      if (cta.actionKey) {
        this.postCampaignAction(cta);
      }
    } else if (cta.serviceInventoryKey !== 'campaigns' && cta.actionKey) {
        this.postCampaignAction(cta);
    } else {
      this._router.navigate([getRouteForKey({key: cta.serviceInventoryKey, route: cta.route})])
    }
  }

  postCampaignAction(cta: CampaignCTA) {
    const actionKey = cta.actionKey;
    this._bsApi.post('api-mobile', `/campaign/${this.activeCampaign()!.key}/actions`, {
      'actionKey': actionKey
    }).subscribe({
      next: response => {
        if (response.result.code === GenericResponseCode.SERVICE_OK) {
          this._campaigns.set(undefined);
          this._serviceInventoryService.loadInventory();
          this._router.navigate([getRouteForKey({key: cta.serviceInventoryKey, route: cta.route})])
        }
      }
    });
  }
}
